
export default {
    name: 'MultiStepForm',
    props: {
        form: {
            type: Object,
            required: true,
        },
        /**
         * Required field, if this field is not present on steps > 1 redirect back to first step
         */
        requiredField: {
            type: Object,
            default() {
                return null;
            },
        },
        steps: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            step: this.$route.query.step || this.steps[0].name,
        };
    },
    computed: {
        currentStep() {
            return this.steps.filter((step) => step.name === this.step)[0] || {};
        },
        nextStep() {
            let next;
            this.steps.forEach((step, index) => {
                if (step.name === this.step && (index < this.steps.length - 1)) {
                    next = this.steps[index + 1];
                }
            });
            return next;
        },
    },
    watch: {
        '$route.query.step': function watchType() {
            this.step = this.$route.query.step || this.steps[0].name;
            if (!process.server) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
    },
    created() {
        this.$store.dispatch('hideNav');
        if (
            (this.$route.query.step && process.server)
            || (this.step !== this.steps[0].name && this.requiredField && !this.requiredField.$model)
        ) {
            if (process.server) {
                this.$clearwaste.context.redirect({ name: this.$route.name });
                return;
            }
            this.$router.replace({ name: this.$route.name });
        }
    },
    methods: {
        async submit(replaceRoute = false) {
            if (this.currentStep.submit) {
                await this.currentStep.submit();
            }
            if (this.nextStep) {
                const route = { ...this.$route, query: { ...this.$route.query, step: this.nextStep.name } };
                if (replaceRoute) {
                    if (process.server) {
                        this.$clearwaste.context.redirect(route);
                        return;
                    }
                    this.$router.replace(route);
                } else {
                    this.$router.push(route);
                }
                this.$store.dispatch('hideNav');
            } else {
                this.$emit('submit');
            }
        },
    },
};

